import { moneyFormat } from '@/filters/toCurrency.filter'
import type { ChartDataset, ChartOptions, DefaultDataPoint } from 'chart.js'

export const lineChartEnvestorBase: ChartDataset<'line', DefaultDataPoint<'line'>> = {
  backgroundColor: 'rgba(251,146,60,1)',
  fill: true,
  label: 'envestor',
  borderColor: 'rgba(255,255,255,0.35)',
  pointBackgroundColor: 'rgba(251,146,60,1)',
  pointBorderColor: 'white',
  pointBorderWidth: 2,
  borderWidth: 2,
  tension: 0.25,
  data: new Array<number>()
}

export const lineChartNormalBase: ChartDataset<'line', DefaultDataPoint<'line'>> = {
  label: 'andere',
  borderColor: '#fff',
  pointBackgroundColor: 'rgba(251,146,60,1)',
  pointBorderColor: 'white',
  backgroundColor: 'rgba(255,255,255,0.35)',
  borderWidth: 2,
  pointBorderWidth: 2,
  fill: true,
  tension: 0.25,
  data: new Array<number>()
}

export const options: ChartOptions = {
  responsive: true,
  interaction: {
    mode: 'index',
    intersect: false
  },
  elements: {
    point: {
      radius: 0
    }
  },
  plugins: {
    tooltip: {
      backgroundColor: '#fff',
      titleColor: '#000',
      bodyColor: '#000',
      borderColor: '#f48a2c',
      borderWidth: 2,
      padding: 10,
      boxPadding: 5,
      displayColors: false,

      callbacks: {
        title: (context) => {
          return 'Jahr ' + context[0].label
        },
        label: function (context) {
          let label = context.dataset.label || ''

          if (label) {
            label += ': '
          }
          if (context.parsed.y !== null) {
            label += moneyFormat(context.parsed.y)
          }
          return label
        }
      }
    },
    legend: {
      display: false
    },
    title: {
      display: true,
      text: 'Depotentwicklung envestor** kontra die Anderen'
    },
    filler: {
      propagate: true
    }
  },
  scales: {
    x: {
      grid: {
        color: '#f5f5f5'
      },
      display: true
    },

    y: {
      grid: {
        color: '#f5f5f5'
      },
      display: true,
      title: {
        display: false,
        text: 'Wert'
      }
    }
  }
}
